import React from 'react';

import { CaseSensitive } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';

export function InitialsFieldIcon(props: SimpleIconInterface): JSX.Element {
  const { className, dataCy, height, stroke, strokeWidth, style, width } = props;

  return (
    <CaseSensitive
      className={className}
      data-cy={dataCy}
      height={height ?? 22}
      stroke={stroke ?? 'currentColor'}
      strokeWidth={strokeWidth ?? 1.5}
      style={{ transform: 'translateY(2px)', ...style }}
      width={width ?? 22}
    />
  );
}
